import BoxInfo from "./BoxInfo";
import DeliveryType from "./DeliveryMethod";
import PickupBranch from "./PickupBranch";
import React, { useContext } from "react";
import PaymentContext from "../../../store/PaymentContext";
import { PaymentConst } from "../../../utils/payment";
import { Select, Switch } from "antd";
import Input from "../Input";
import Province from "./Province";
import Ward from "./Ward";
import District from "./District";

interface IProps {

}
const Delivery: React.FC<IProps> = ({ }) => {
    const {
        rentCustomer,
        sellCustomer,
        tabActiveStep1,
        setSellCustomer,
        setRentCustomer,
        sellAdditionalInformation,
        rentAdditionalInformation,

        rentCustomerApply,
        setRentCustomerApply,

        sellCustomerApply,
        setSellCustomerApply,

        sellCustomerError,
        rentCustomerError,

        setRentCustomerError,
        setSellCustomerError,
        isMobile,
        handleCalculateFee,
        rentCarts,
        sellCarts,
    }: any = useContext(PaymentContext)

    const customer = Number(tabActiveStep1) === Number(PaymentConst.TabConst.rent) ? rentCustomer : sellCustomer
    const setCustomer = Number(tabActiveStep1) === Number(PaymentConst.TabConst.rent) ? setRentCustomer : setSellCustomer;
    const additionalInformation = Number(tabActiveStep1) === Number(PaymentConst.TabConst.rent) ? rentAdditionalInformation : sellAdditionalInformation;

    const errors = Number(tabActiveStep1) === Number(PaymentConst.TabConst.rent) ? rentCustomerError : sellCustomerError;
    const setErrors = Number(tabActiveStep1) === Number(PaymentConst.TabConst.rent) ? setRentCustomerError : setSellCustomerError;
    
    const handleOnChangeValue = (key: string, value: string) => {
        setCustomer({
            ...customer,
            [key]: value
        })

        if (value) {
            if (key == 'phone') {
                let validatePhone = /^0\(?(\d{2})\)?[- ]?(\d{3})[- ]?(\d{4})$/;
                if (!validatePhone.test(value)) {
                    setErrors({
                        ...errors,
                        [key]: 'Số điện thoại không hợp lệ',
                    })
                    return;
                }
            }

            setErrors({
                ...errors,
                [key]: '',
            })
        } else {
            setErrors({
                ...errors,
                [key]: PaymentConst.LabelCustomer[key] + ' không được bỏ trống',
            })
        }
    }

    const handleChangeSelectValue = async (key: string, value: any) => {
        await setCustomer((pre: any) => {
            return {
                ...pre,
                [`${key}_id`]: value?.id ?? null,
                [`${key}_name`]: value?.name ?? null,
            }
        })
        reloadFeeTransport();

        await setErrors({
            ...errors,
            [`${key}_id`]: '',
        })
    }

    function reloadFeeTransport(){
        const carts = Number(tabActiveStep1) === Number(PaymentConst.TabConst.rent) ? rentCarts : sellCarts;
        const baseCustomer = Number(tabActiveStep1) === Number(PaymentConst.TabConst.rent) ? rentCustomer : sellCustomer
        if(baseCustomer?.province_name && baseCustomer?.district_name && baseCustomer?.address){
            handleCalculateFee(
                carts,
                Number(tabActiveStep1) === Number(PaymentConst.TabConst.buy),
                baseCustomer,
                {
                    ...additionalInformation,
                }
            );
        }
    }

    return (
        <div className={`delivery-information w-full flex flex-col gap-4 rounded ${isMobile ? '' : 'mt-4'}`}>
            <div className="heading rounded uppercase text-lg">Thông tin Nhận hàng</div>
            <div className="content rounded">
                <div className="p-4 grid grid-cols-1 gap-4 ">
                    <div className="flex justify-between items-center">
                        <span className="text-lg bold">Thông tin người nhận</span>
                        {/*<div className="flex gap-1">*/}
                        {/*    <Switch*/}
                        {/*        checked={tabActiveStep1 === PaymentConst.TabConst.rent ? rentCustomerApply : sellCustomerApply}*/}
                        {/*        className={'background-color-secondary'}*/}
                        {/*        onClick={() => {*/}
                        {/*            if(tabActiveStep1 === PaymentConst.TabConst.rent) {*/}
                        {/*                setRentCustomerApply(!rentCustomerApply);*/}
                        {/*                if(!rentCustomerApply === true) {*/}
                        {/*                    setSellCustomerApply(rentCustomerApply)*/}
                        {/*                }*/}
                        {/*            }else {*/}
                        {/*                setSellCustomerApply(!sellCustomerApply)*/}
                        {/*                if(!sellCustomerApply === true) {*/}
                        {/*                    setRentCustomerApply(sellCustomerApply)*/}
                        {/*                }*/}
                        {/*            }*/}
                        {/*        }}*/}
                        {/*    /> <span>{ tabActiveStep1 === PaymentConst.TabConst.rent ? 'Áp dụng cho đơn mua' : 'Áp dụng cho đơn thuê' }</span>*/}
                        {/*</div>*/}
                    </div>
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                        <BoxInfo
                            label="Họ và tên"
                            content={(
                                <>
                                    <Input
                                        name={'name'}
                                        value={customer.name}
                                        onChange={(event: Event | any) => {
                                            handleOnChangeValue('name', event.target.value);
                                        }}
                                    />
                                    {errors?.name && <span className="color-danger">{errors.name}</span>}
                                </>
                            )}
                        />
                        {/*<BoxInfo*/}
                        {/*    label="Địa chỉ email"*/}
                        {/*    content={(*/}
                        {/*        <>*/}
                        {/*            <Input*/}
                        {/*                name={'email'}*/}
                        {/*                value={customer.email}*/}
                        {/*                onChange={(event: Event|any) => {*/}
                        {/*                    handleOnChangeValue('email', event.target.value);*/}
                        {/*                }}*/}
                        {/*            />*/}
                        {/*            { errors?.email && <span className="color-danger">{ errors.email }</span> }*/}
                        {/*        </>*/}
                        {/*    )}*/}
                        {/*/>*/}

                        <BoxInfo
                            label="Số điện thoại"
                            content={(
                                <>
                                    <Input
                                        name={'phone'}
                                        value={customer.phone}
                                        onChange={(event: Event | any) => {
                                            handleOnChangeValue('phone', event.target.value);
                                        }}
                                    />
                                    {errors?.phone && <span className="color-danger">{errors.phone}</span>}
                                </>
                            )}
                        />

                        <BoxInfo
                            label="Email"
                            content={(
                                <>
                                    <Input
                                        name={'email'}
                                        value={customer.email}
                                        onChange={(event: Event | any) => {
                                            handleOnChangeValue('email', event.target.value);
                                        }}
                                    />
                                    {errors?.email && <span className="color-danger">{errors.email}</span>}
                                </>
                            )}
                        />
                        <BoxInfo
                            label="Giới tính"
                            content={(
                                <>
                                    <Select
                                        className="w-full mt-1 bg-transparent"
                                        value={customer.sex}
                                        onChange={(value) => {
                                            setCustomer({
                                                ...customer,
                                                sex: value
                                            })
                                        }}

                                        options={[
                                            { label: 'Nam', value: 0 },
                                            { label: 'Nữ', value: 1 },
                                            { label: 'Khác', value: 2 },
                                        ]}
                                    />

                                    {errors?.sex && <span className="color-danger text-sm">{errors.sex}</span>}
                                </>

                            )}
                        />


                        <Province
                            value={customer.province_id}
                            textLabel={customer.province_name}
                            onChange={async (value: any, option: any) => {
                                await handleChangeSelectValue('province', option)
                                await handleChangeSelectValue('district', {})
                                await handleChangeSelectValue('ward', {})
                            }}
                            error={errors?.province_id}
                        />
                        <District
                            textLabel={customer.district_name}
                            value={customer.district_id}
                            onChange={async (value: any, option: any) => {
                                await handleChangeSelectValue('district', option)
                                await handleChangeSelectValue('ward', {})
                            }}
                            error={errors?.district_id}
                            parent_id={customer.province_id}
                        />
                        <Ward
                            textLabel={customer.ward_name}
                            value={customer.ward_id}
                            onChange={(value: any, option: any) => {
                                handleChangeSelectValue('ward', option)
                            }}
                            error={errors?.ward_id}
                            parent_id={customer.district_id}
                        />

                        <BoxInfo
                            label="Địa chỉ người nhận"
                            content={(
                                <>
                                    <Input
                                        name={'address'}
                                        value={customer.address}
                                        onChange={(event: Event | any) => {
                                            handleOnChangeValue('address', event.target.value);
                                            reloadFeeTransport();
                                        }}
                                    />
                                    {errors?.address && <span className="color-danger">{errors.address}</span>}
                                </>
                            )}
                        />

                    </div>
                    <div className={`grid gap-4 ${additionalInformation.delivery_type === PaymentConst.DeliveryType.pickupDirectly ? 'grid-cols-1 md:grid-cols-2' : ''}`}>
                        {/*<div className="col-span-2">*/}
                        {/*    <TransactionType />*/}
                        {/*</div>*/}
                        <DeliveryType />
                        {
                            additionalInformation.delivery_type === PaymentConst.DeliveryType.pickupDirectly && (
                                <PickupBranch />
                            )
                        }

                    </div>

                    <div className="mb-4">
                        <textarea
                            rows={3}
                            placeholder="Ghi chú"
                            value={customer.note}
                            onChange={(event) => {
                                setCustomer({
                                    ...customer,
                                    note: event.target.value,
                                })
                            }}
                        />
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Delivery;
